import { DropZoneComponent } from './DropZone.component';
import { enhance } from './DropZone.enhancers';

export const DropZone = enhance(DropZoneComponent);
